import { sensors, isNode } from '@tyc-pc/core';
import { getFCP, getLCP } from 'web-vitals';
import getPageName from './getPageName';

interface reportDataProps {
  da_version: number;
  plat_type: string;
  page_id: string;
  page_name: string;
  page: string;
  FCP?: number;
  LCP?: number;
}

const getSensorsPageInfo = () => {
  const page = getPageName();
  switch (page) {
    case 'home':
      return {
        pageId: 'Home',
        pageName: '首页',
      };
    case 'vipintro':
      return {
        pageId: 'VipPackage',
        pageName: 'VIP会员页',
      };
    case 'vipbusiness':
      return {
        pageId: 'VipBusinessPackage',
        pageName: 'VIP企业套餐页',
      };
    case 'search':
      return {
        pageId: 'SearchResult',
        pageName: '主搜搜索结果页',
      };
    case 'company':
      return {
        pageId: 'CompanyDetail',
        pageName: '公司详情页',
      };
    case 'human':
      return {
        pageId: 'PersonDetail',
        pageName: '人员详情页',
      };
    default:
      return {
        pageId: '',
        pageName: '',
      };
  }
};

/**
 * 将 FCP、LCP 上报到神策
 * 目的：按地域（北京、上海、武汉等）查看 FCP、LCP 一周的 P50、P90 数值
 */
const reportWebPerformanceData = (data: { name: string; value: number }) => {
  const { name, value } = data;
  const { pageId, pageName } = getSensorsPageInfo();
  if (['FCP', 'LCP'].includes(name) && pageId && pageName) {
    const reportData: reportDataProps = {
      da_version: 1005,
      plat_type: 'Web',
      page_id: pageId,
      page_name: pageName,
      page: window.location.href,
      [name]: Math.round(value),
    };
    sensors.track('WebQos', reportData);
  }
};

const reportWebVitals = () => {
  if (isNode) return;
  getFCP(reportWebPerformanceData);
  getLCP(reportWebPerformanceData);
};

export default reportWebVitals;
